












































import { Component, Emit, Prop, Vue } from 'vue-property-decorator'

@Component

export default class ComponentCreditCard extends Vue {
  @Prop(Object) card

  @Emit('actionClick')
  actionClick() {}
}
